import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function AutoRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    // Open the new URL in a new tab
    window.open("http://arreportsql/ReportServer/Pages/ReportViewer.aspx?%2fTHRaporlar%2fGenel%2fServisFotograflari&rs:Command=Render", '_blank');

    // Go back to the previous URL
    navigate(-1);
  }, [navigate]);

  // Return null to render nothing
  return null;
}

export default AutoRedirect;
